<template>
  <div class="faq-section">
    <SectionCard class="faq-card">
      <SectionHeader
        title="Domande Frequenti"
        subtitle="Tutto quello che vuoi sapere sui nostri servizi"
      />
      <div class="accordion">
        <AccordionItem
          title="Come posso generare il mio codice lotteria?"
          :default-open="true"
        >
          <p><strong>Importante:</strong> Questa non è un'app ufficiale, ma uno strumento di supporto che ti aiuta nella gestione dei tuoi codici lotteria.</p>
          
          <p><strong>Su Android:</strong> Attraverso l'app App Lotteria degli Scontrini, verrai reindirizzato al sito ufficiale della Lotteria degli Scontrini 
          dove potrai generare il tuo codice utilizzando il tuo codice fiscale. L'app ti guiderà passo dopo passo 
          nel processo.</p>
          
          <p><strong>Su iOS:</strong> La generazione automatica del codice non è disponibile. Dovrai accedere direttamente al 
          <a href="https://www.lotteriadegliscontrini.gov.it" target="_blank" rel="noopener noreferrer">sito istituzionale della Lotteria degli Scontrini</a> 
          per generare il tuo codice utilizzando il tuo codice fiscale.</p>
        </AccordionItem>
        
        <AccordionItem title="I miei dati sono sicuri?">
          <p>Sì, tutti i dati vengono memorizzati esclusivamente sul tuo dispositivo. 
          Non vengono inviati dati a server esterni, ad eccezione delle comunicazioni 
          necessarie per accedere al sito governativo della Lotteria degli Scontrini. 
          La tua privacy è la nostra priorità.</p>
          
          <p><strong>Nota:</strong> Questa app è uno strumento di supporto non ufficiale. 
          Per informazioni ufficiali e per la generazione dei codici, fai sempre riferimento al 
          <a href="https://www.lotteriadegliscontrini.gov.it" target="_blank" rel="noopener noreferrer">sito istituzionale</a>.</p>
        </AccordionItem>
        
        <AccordionItem title="Cosa succede se disinstallo l'app?">
          <p>Se disinstalli l'app, tutti i dati memorizzati localmente verranno eliminati. 
          Potrai sempre reinstallare l'app e generare un nuovo codice lotteria quando vorrai. 
          I dati non vengono salvati su server esterni, quindi la disinstallazione rimuove completamente 
          tutte le informazioni salvate.</p>
          
          <p><strong>Ricorda:</strong> I tuoi codici lotteria ufficiali sono sempre disponibili sul 
          <a href="https://www.lotteriadegliscontrini.gov.it" target="_blank" rel="noopener noreferrer">sito istituzionale</a>, 
          indipendentemente dall'app.</p>
        </AccordionItem>
      </div>
    </SectionCard>
  </div>
</template>

<script>
import SectionHeader from '../../components/contattaci/SectionHeader.vue'
import SectionCard from '../../components/contattaci/SectionCard.vue'
import AccordionItem from '../../components/contattaci/AccordionItem.vue'

export default {
  name: 'ContactFaq',
  components: {
    SectionHeader,
    SectionCard,
    AccordionItem
  }
}
</script>

<style scoped>
.faq-section {
  margin-bottom: 80px;
}

.faq-card {
  max-width: 900px;
}

.accordion {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.accordion-body a {
  color: #2a5298;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.accordion-body a:hover {
  color: #1a3d7a;
}

.accordion-body p {
  margin-bottom: 12px;
}

.accordion-body p:last-child {
  margin-bottom: 0;
}
</style>

